/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Field, Form } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import { ForgotUserNameSchema } from '../../../schemas/auth'
import InputError from '../../../components/InputError/InputError'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoButton from '../../../components/NeoButton/NeoButton'
import WinnersTrophy from 'custom/assets/icons/signup/signup-success'
import { DIALOG_KEYS, AUTH_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import AuthLayout from '../auth-layout'
import AuthService from '../../../services/auth.service'
import config from 'custom/config/environment'

import validationConfig from 'custom/config/validation.config.json'
const forgotUsernameConfig = validationConfig['forgotUsername']

export default function ForgotUsername() {
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [formValues, setFormValues] = useState({
    srcAccount: '',
    mobileNo: '',
    countryCode: config.COUNTRY_CODE,
    customerDob: '',
    uniqueIdValue: '',
    uniqueIdType: '',
  })
  const [otp, setOtp] = useState('')
  const history = useHistory()
  const { t } = useTranslation()
  const [otpRequired, setOtpRequired] = useState(false)
  const [countryCodesList, setCountryCodesList] = useState([])

  const uniqueIdTypes = {
    PASSPORT: t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.PASSPORT_NO),
    NATIONALID: t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.NATIONAL_ID),
    VOTERID: t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.VOTER_ID),
    DRIVINGLICENCE: t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.DRIVING_LICENCE),
  }

  useEffect(()=>{
    getCountryCodeList()
  },[])

  const getCountryCodeList = useCallback(async () => {
    try {
      setLoading(true)
      const response = await AuthService.getCountryCodes()
      setCountryCodesList(response.countryCodeList)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  })

  const verifyAccountNumber = useCallback(async (data) => {
    try {
      setLoading(true)
      setFormValues(data)
      const response = await AuthService.verifyForgotUsername({
        srcAccount: data.srcAccount,
        countryCode: data.countryCode,
        mobileNo: data.mobileNo,
        uniqueIdType: data.uniqueIdType,
        uniqueIdValue: data.uniqueIdValue,
        username: 'DEFAULT',
        customerDob: data.customerDob,
        relationshipType: 'ACCOUNT',
      })
      if (response.status === 200) {
        setOtpRequired(response.data.otpEnable)
        setLoading(false)
        setStage(2)
      } else {
        setOtpRequired(false)
        setOtp('0000')
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const registerUserSubmit = useCallback(
    async (data) => {
      try {
        setLoading(true)
        const response = await AuthService.verifyForgotUsernameConfirm({
          mobileNo: formValues.mobileNo,
          srcAccount: formValues.srcAccount,
          otp: otp,
          countryCode: formValues.countryCode,
          uniqueIdType: formValues.uniqueIdType,
          uniqueIdValue: formValues.uniqueIdValue,
          customerDob: formValues.customerDob,
          username: 'DEFAULT',
          relationshipType: 'ACCOUNT',
        })
        if (response.status === 200) {
          setMessage(response.data.message)
          setLoading(false)
          setStage(3)
        }
      } catch (err) {
        setLoading(false)
        setOtp('')
      }
    },
    [otp, formValues, otpRequired],
  )

  // useEffect(() => {
  //   const getValues = async () => {
  //     await fetchCountryCodes()
  //   }
  //   getValues()
  // }, [])

  function getMaxDoB() {
    const today = new Date()
    const dates = [today.getFullYear() - config.DOB_MINOR_AGE_VALIDATION, today.getMonth() + 1, today.getDate() - 1]
    return `${dates[0]}-${dates[1] < 10 ? '0' + dates[1] : dates[1]}-${dates[2] < 10 ? '0' + dates[2] : dates[2]}`
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <Formik
        enableReinitialize
        onSubmit={verifyAccountNumber}
        validationSchema={ForgotUserNameSchema}
        initialValues={formValues}>
        {({ errors, touched, setFieldValue, handleChange, values }) => (
          <Form>
            <div className='row'>
              <div className='form-group col-12'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={forgotUsernameConfig['isAccountNoRequired']}
                  name='srcAccount'
                  text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.ACCOUNT_NUMBER)}
                  icon='account_balance'
                  mode='onlyNumber'
                  onChange={(value) => {
                    setFieldValue('srcAccount', value?.value)
                  }}
                  placeholder={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.ACCOUNT_NUMBER)}
                  value={values.srcAccount}
                />
                <InputError text={errors.srcAccount} touched={touched.srcAccount} />
              </div>

              <div className='form-group col-12'>
                <p className='control-label'>
                {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.MOBILE_NUMBER)} {forgotUsernameConfig['isPhoneNoRequired'] ? '*' : ''}
                </p>
                <div className='row '>
                  <div className='col-4 text-center' style={{ marginTop: '-22px' }}>            
                    <NeoInput
                      tabIndex='2'
                      mode='select'
                      name='countryCode'
                      icon='phone'
                      keyValue="isdCode"
                      value={values.countryCode}
                      list={countryCodesList}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className='col-8'
                    style={{ marginTop: '-23px', marginLeft: '-15px', paddingRight: '0px' }}>
                    <NeoInput
                      tabIndex='3'
                      name='mobileNo'
                      icon='phone'
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('mobileNo', value?.value)
                      }}
                      placeholder={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.MOBILE_NUMBER)}
                      value={values.mobileNo}
                    />
                  </div>
                </div>
                <InputError text={errors.mobileNo} touched={touched.mobileNo} />
              </div>
              <div className='form-group col-12'>
                <NeoInput
                  tabIndex='4'
                  showAsterisk={forgotUsernameConfig['isDOBRequired']}
                  name='customerDob'
                  text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.DOB)}
                  icon='calendar_today'
                  value={values.customerDob}
                  mode='single'
                  type='date'
                  onChange={handleChange}
                  placeholder={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.DOB)}
                  max={getMaxDoB()}
                />
                <InputError text={errors.customerDob} touched={touched.customerDob} />
              </div>
              <div className='form-group col-12'>
              <label className='control-label'>
                    {t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.IDENTITY_TYPE)}{' '}
                    {forgotUsernameConfig['isUniqueIdRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex='5'
                    as='select'
                    name='uniqueIdType'
                    className='form-control'
                    onChange={handleChange}>
                    <option value='' />
                    {config.UNIQUE_ID_TYPE.map((option, index) => (
                      <option value={option} key={index}>
                        {uniqueIdTypes[option]}
                      </option>
                    ))}
                  </Field>
                <InputError text={errors.uniqueIdType} touched={touched.uniqueIdType} />
              </div>

              <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='6'
                    showAsterisk={forgotUsernameConfig['isUniqueIdRequired']}
                    mode='single'
                    text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.IDENTITY_NO)}
                    name='uniqueIdValue'
                    value={values.uniqueIdValue}
                    icon='perm_identity'
                    onChange={handleChange}
                  />
                  <InputError text={errors.uniqueIdValue} touched={touched.uniqueIdValue} /> 
                </div>

              {/* {values.identityType === 'Passport No.' && (
                <div className='form-group col-12'>
                  <NeoInput
                    showAsterisk={forgotUsernameConfig['isIdentityTypeRequired']}
                    mode='single'
                    text={'Passport No.'}
                    name='passport'
                    value={values.passport}
                    icon='perm_identity'
                    onChange={handleChange}
                  />
                  <InputError text={errors.passport} touched={touched.passport} />
                </div>
              )}

              {values.identityType === 'National ID' && (
                <div className='form-group col-12'>
                  <NeoInput
                    showAsterisk={forgotUsernameConfig['isIdentityTypeRequired']}
                    mode='onlyNumber'
                    name='nationalId'
                    text={'National ID'}
                    value={values.nationalId}
                    icon='perm_identity'
                    onChange={(values) => {
                      setFieldValue('nationalId', values.value)
                    }}
                    placeholder={'National ID'}
                  />
                  <InputError text={errors.nationalId} touched={touched.nationalId} />
                </div>
              )} */}

              <div className='form-group col-12'>
                <TermsAndCondition tabIndex='7' module="FORGOTUSERNAME" />
              </div>
            </div>

            <div className='my-3' />
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton tabIndex='8' text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.SUBMIT)} mode='newDesign' type='submit' />
            )}
  
            <div className='back-cancel-btn-container'>
            <button className='back-cancel-btn btn btn-sm new-design-warning-text-color ' onClick={() => history.push('/login')} tabIndex='9'>
            {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.LOGIN)}
            </button>
            </div>
          </Form>
        )}
      </Formik>
    )
  }

  function renderSuccess() {
    return (
      <div className='row justify-content-center'>
        <WinnersTrophy width='250' height='250' />
        <p className='lead'>{message}</p>
        <div className='my-3' />
        <NeoButton
          text={t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.LOGIN_KEYS.LOGIN_BUTTON)}
          type='submit'
          mode='newDesign'
          onClick={() => {
            history.push('/login')
          }}
        />
        <div style={{ height: 200 }}></div>
      </div>
    )
  }

  const renderSignupStage = () => {
    switch (stage) {
      case 0:
        return renderForm()
      case 1:
        return renderForm()
      case 2:
        return (
          <div>
            <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={registerUserSubmit} />
            <div style={{ height: 200 }}></div>
          </div>
        )
      case 3:
        return renderSuccess()
      default:
        return renderForm()
    }
  }

  return (
    <AuthLayout>
      <div className='container col mt-5 ' style={{ width: '400px' }}>
        <h3 className='register-with-us-tod'>{t(AUTH_KEYS.LOGIN_CONTAINER_KEYS.SIGN_UP_KEYS.SUBTITLE_2)}</h3>
        <div className='my-2' />
        {renderSignupStage()}
      </div>
    </AuthLayout>
  )
}
